// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__qfQ1G","selected":"Chip_selected__3D6cq"};